import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DigitalcouponRequestExportCsv, DigitalcouponRequestSearch } from '../../../models/api-appointment/digital-coupon/digital-coupon.request.model';
import { DigitalcouponResponse, DigitalcouponResponseExport, DigitalcouponResponseSearch } from '../../../models/api-appointment/digital-coupon/digital-coupon.response.model';

@Injectable({
  providedIn: 'root'
})
export class DigitalCouponService {

  constructor(private http: HttpClient) { }
  pathUrl: string = environment.backend.pathUrl.appointment.digital_coupon;
  baseUrl: string = environment.backend.baseUrl_appuntamenti;
  url: string = this.baseUrl + this.pathUrl;
  
  getEntity(id: number): Observable<DigitalcouponResponse> {
    let url = this.url +"/" + id;
    return this.http.get<DigitalcouponResponse>(url);
  }

  exportCSV(request:DigitalcouponRequestExportCsv):Observable<DigitalcouponResponseExport>{
    let url = this.url +"/" +"exportCsv";
    return this.http.post<DigitalcouponResponseExport>(url,request);
  }

  search(request:DigitalcouponRequestSearch):Observable<DigitalcouponResponseSearch>{
    let url = this.url +"/" +"search";
    return this.http.post<DigitalcouponResponseSearch>(url,request);
  }

}
